"use strict";

/*==============================================================================*
*TRESTLE™ W004
*POPUP TOOL — SHE FITNESS ASSESSMENT
*==============================================================================*/

window.TRESTLE_W004_TOOLS =
window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.she_fitness_assessment = {


/*==============================================================================*
*RENDER
*==============================================================================*/

render(){

    return `

    <div class="tr-w004-fitness-tool">

        <div class="fitness-assessment">


            <p class="fitness-intro">
                Know Your Fitness. Improve Your Future.
            </p>


            <div class="fitness-progress-wrap">

                <div
                class="fitness-progress"
                data-fitness-progress>
                </div>

            </div>


            <form data-fitness-form>


                <!--==========================================================
                STEP 1
                ==========================================================-->

                <div
                class="fitness-step active"
                data-fitness-step>

                    <h3>Step 1: About You</h3>

                    <label>Age</label>

                    <input
                    type="number"
                    data-fitness-age>


                    <label>Height (cm)</label>

                    <input
                    type="number"
                    data-fitness-height>


                    <label>Weight (kg)</label>

                    <input
                    type="number"
                    data-fitness-weight>

                </div>


                <!--==========================================================
                STEP 2
                ==========================================================-->

                <div
                class="fitness-step"
                data-fitness-step>

                    <h3>Step 2: Life Stage & Health</h3>


                    <label>Life Stage</label>

                    <select data-fitness-stage>

                        <option>Young Woman</option>
                        <option>Working Professional</option>
                        <option>Homemaker</option>
                        <option>Women 40+</option>
                        <option>Menopause</option>
                        <option>Active Senior</option>

                    </select>


                    <label>Diabetes Status</label>

                    <select data-fitness-diabetes>

                        <option>No Diabetes</option>
                        <option>Prediabetes</option>
                        <option>Type 1 Diabetes</option>
                        <option>Type 2 Diabetes</option>

                    </select>

                </div>


                <!--==========================================================
                STEP 3
                ==========================================================-->

                <div
                class="fitness-step"
                data-fitness-step>

                    <h3>Step 3: Movement</h3>


                    <label>Walking Days Per Week</label>

                    <select data-fitness-walk>

                        <option value="0">Never</option>
                        <option value="5">1-2 Days</option>
                        <option value="10">3-4 Days</option>
                        <option value="15">5+ Days</option>

                    </select>


                    <label>Daily Steps</label>

                    <select data-fitness-steps>

                        <option value="0">Under 3000</option>
                        <option value="5">3000-5000</option>
                        <option value="10">5000-8000</option>
                        <option value="15">Above 8000</option>

                    </select>


                    <label>Sitting Hours</label>

                    <select data-fitness-sit>

                        <option value="15">Less than 4</option>
                        <option value="10">4-6</option>
                        <option value="5">6-8</option>
                        <option value="0">More than 8</option>

                    </select>

                </div>


                <!--==========================================================
                STEP 4
                ==========================================================-->

                <div
                class="fitness-step"
                data-fitness-step>

                    <h3>Step 4: Fitness</h3>


                    <label>Strength Training</label>

                    <select data-fitness-strength>

                        <option value="0">Never</option>
                        <option value="5">Occasionally</option>
                        <option value="10">Weekly</option>
                        <option value="15">2+ Times Weekly</option>

                    </select>


                    <label>Stretching</label>

                    <select data-fitness-stretch>

                        <option value="0">Never</option>
                        <option value="5">Occasionally</option>
                        <option value="10">Weekly</option>
                        <option value="15">Most Days</option>

                    </select>


                    <label>
                        Can you comfortably climb two flights of stairs?
                    </label>

                    <select data-fitness-stairs>

                        <option value="10">Yes</option>
                        <option value="0">No</option>

                    </select>

                </div>


                <!--==========================================================
                STEP 5
                ==========================================================-->

                <div
                class="fitness-step"
                data-fitness-step>

                    <h3>Step 5: Wellness & Goals</h3>


                    <label>Energy Level</label>

                    <select data-fitness-energy>

                        <option value="0">Low</option>
                        <option value="5">Moderate</option>
                        <option value="10">Good</option>
                        <option value="15">Excellent</option>

                    </select>


                    <label>Sleep Quality</label>

                    <select data-fitness-sleep>

                        <option value="0">Poor</option>
                        <option value="5">Fair</option>
                        <option value="10">Good</option>
                        <option value="15">Excellent</option>

                    </select>


                    <label>Stress Level</label>

                    <select data-fitness-stress>

                        <option value="15">Rarely</option>
                        <option value="10">Sometimes</option>
                        <option value="5">Often</option>
                        <option value="0">Almost Daily</option>

                    </select>


                    <label>Primary Goal</label>

                    <select data-fitness-goal>

                        <option>Weight Management</option>
                        <option>Blood Sugar Control</option>
                        <option>Strength</option>
                        <option>Mobility</option>
                        <option>Overall Fitness</option>

                    </select>

                </div>


                <!--==========================================================
                CONTROLS
                ==========================================================-->

                <div class="fitness-buttons">

                    <button
                    type="button"
                    class="fitness-secondary-btn"
                    data-fitness-prev>

                        Previous

                    </button>


                    <button
                    type="button"
                    class="fitness-primary-btn"
                    data-fitness-next>

                        Next

                    </button>


                    <button
                    type="button"
                    class="fitness-primary-btn"
                    data-fitness-calculate
                    hidden>

                        Calculate Score

                    </button>

                </div>


            </form>


            <!--==============================================================
            RESULT
            ===============================================================-->

            <div
            class="fitness-result"
            data-fitness-result
            hidden>


                <div
                class="fitness-score-circle"
                data-fitness-score>

                    0

                </div>


                <h3 data-fitness-status></h3>


                <div
                class="fitness-notice"
                data-fitness-meaning>
                </div>


                <h4>Potential Concerns</h4>

                <ul data-fitness-risks></ul>


                <h4>Recommended Fitness Path</h4>

                <ul data-fitness-recommendations></ul>


                <div class="fitness-result-buttons">

                    <button
                    type="button"
                    class="fitness-secondary-btn"
                    data-fitness-edit>

                        Edit My Answers

                    </button>


                    <button
                    type="button"
                    class="fitness-primary-btn"
                    data-fitness-reset>

                        Take Assessment Again

                    </button>

                </div>


            </div>


        </div>

    </div>

    `;

},


/*==============================================================================*
*INIT
*==============================================================================*/

init(root){

    if(!root){

        return;

    }


    let current = 0;


    const form =
        root.querySelector("[data-fitness-form]");


    const steps =
        Array.from(
            root.querySelectorAll("[data-fitness-step]")
        );


    const progress =
        root.querySelector("[data-fitness-progress]");


    const prevButton =
        root.querySelector("[data-fitness-prev]");


    const nextButton =
        root.querySelector("[data-fitness-next]");


    const calculateButton =
        root.querySelector("[data-fitness-calculate]");


    const result =
        root.querySelector("[data-fitness-result]");


    const scoreCircle =
        root.querySelector("[data-fitness-score]");


    const statusElement =
        root.querySelector("[data-fitness-status]");


    const meaningElement =
        root.querySelector("[data-fitness-meaning]");


    const risksElement =
        root.querySelector("[data-fitness-risks]");


    const recommendationsElement =
        root.querySelector("[data-fitness-recommendations]");


    const editButton =
        root.querySelector("[data-fitness-edit]");


    const resetButton =
        root.querySelector("[data-fitness-reset]");


/*==============================================================================*
*UPDATE UI
*==============================================================================*/

    const updateUI = ()=>{

        steps.forEach(

            (step,index)=>{

                step.classList.toggle(
                    "active",
                    index === current
                );

            }

        );


        if(progress){

            progress.style.width =
                ((current + 1) * 20) + "%";

        }


        if(prevButton){

            prevButton.style.visibility =
                current === 0
                    ? "hidden"
                    : "visible";

        }


        if(nextButton){

            nextButton.hidden =
                current === 4;

        }


        if(calculateButton){

            calculateButton.hidden =
                current !== 4;

        }

    };


/*==============================================================================*
*NEXT / PREVIOUS
*==============================================================================*/

    if(nextButton){

        nextButton.addEventListener(

            "click",

            ()=>{

                if(current < 4){

                    current++;

                    updateUI();

                }

            }

        );

    }


    if(prevButton){

        prevButton.addEventListener(

            "click",

            ()=>{

                if(current > 0){

                    current--;

                    updateUI();

                }

            }

        );

    }


/*==============================================================================*
*CALCULATE
*==============================================================================*/

    const calculateScore = ()=>{


        const getNumber = (selector)=>{

            const element =
                root.querySelector(selector);

            return element
                ? parseInt(element.value,10) || 0
                : 0;

        };


        let score = 0;


        [
            "[data-fitness-walk]",
            "[data-fitness-steps]",
            "[data-fitness-sit]",
            "[data-fitness-strength]",
            "[data-fitness-stretch]",
            "[data-fitness-stairs]",
            "[data-fitness-energy]",
            "[data-fitness-sleep]",
            "[data-fitness-stress]"

        ].forEach(

            (selector)=>{

                score += getNumber(selector);

            }

        );


        score = Math.min(score,100);


        let status = "High Priority";


        if(score >= 80){

            status = "Excellent";

        }

        else if(score >= 60){

            status = "Moderately Active";

        }

        else if(score >= 40){

            status = "Needs Improvement";

        }


        let meaning = "";


        if(status === "Excellent"){

            meaning =
                "Your activity and wellness habits are supporting long-term health.";

        }

        else if(status === "Moderately Active"){

            meaning =
                "You have a good foundation but could benefit from more structured activity.";

        }

        else if(status === "Needs Improvement"){

            meaning =
                "Regular movement may help improve strength, energy and metabolic health.";

        }

        else{

            meaning =
                "Your responses suggest a sedentary lifestyle requiring immediate attention.";

        }


        const stageElement =
            root.querySelector("[data-fitness-stage]");


        const goalElement =
            root.querySelector("[data-fitness-goal]");


        const stage =
            stageElement
                ? stageElement.value
                : "";


        const goal =
            goalElement
                ? goalElement.value
                : "";


        let risks = [];


        if(score < 60){

            risks.push(
                "Reduced insulin sensitivity",
                "Weight gain and abdominal fat accumulation",
                "Loss of muscle strength",
                "Lower energy levels"
            );

        }


        if(stage === "Menopause"){

            risks.push(
                "Bone density decline",
                "Reduced mobility"
            );

        }


        if(stage === "Active Senior"){

            risks.push(
                "Higher fall risk",
                "Loss of independence"
            );

        }


        let recommendations = [];


        if(goal === "Weight Management"){

            recommendations = [
                "Walk 30 minutes 5 days weekly",
                "Strength train twice weekly",
                "Reduce sitting time"
            ];

        }

        else if(goal === "Blood Sugar Control"){

            recommendations = [
                "Take post-meal walks",
                "Strength train twice weekly",
                "Aim for 7000+ daily steps"
            ];

        }

        else if(goal === "Strength"){

            recommendations = [
                "Resistance training 2-3 times weekly",
                "Progressive strength exercises",
                "Daily mobility work"
            ];

        }

        else if(goal === "Mobility"){

            recommendations = [
                "Daily stretching",
                "Balance exercises",
                "Yoga or flexibility training"
            ];

        }

        else{

            recommendations = [
                "Walk regularly",
                "Strength train twice weekly",
                "Stretch daily"
            ];

        }


        scoreCircle.innerHTML =
            score + "<small>/100</small>";


        statusElement.textContent =
            status;


        meaningElement.textContent =
            meaning;


        risksElement.innerHTML =
            risks.length
                ? risks.map(
                    (item)=>`<li>${item}</li>`
                  ).join("")
                : "<li>No major concerns indicated by this assessment.</li>";


        recommendationsElement.innerHTML =
            recommendations.map(
                (item)=>`<li>${item}</li>`
            ).join("");


        form.hidden = true;

        result.hidden = false;


        result.scrollIntoView({

            behavior:"smooth",

            block:"nearest"

        });

    };


    if(calculateButton){

        calculateButton.addEventListener(
            "click",
            calculateScore
        );

    }


/*==============================================================================*
*EDIT ANSWERS
*==============================================================================*/

    if(editButton){

        editButton.addEventListener(

            "click",

            ()=>{

                result.hidden = true;

                form.hidden = false;

                current = 4;

                updateUI();

            }

        );

    }


/*==============================================================================*
*RESET
*==============================================================================*/

    if(resetButton){

        resetButton.addEventListener(

            "click",

            ()=>{

                form.reset();

                result.hidden = true;

                form.hidden = false;

                current = 0;

                updateUI();

            }

        );

    }


/*==============================================================================*
*INITIAL STATE
*==============================================================================*/

    updateUI();

}

};